export const removeFalsyKeys = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => value)) as Partial<T>;

export const removeNullOrUndefinedKeys = <T extends { [key: string]: any }>(obj: T): T =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== null && value !== undefined),
  ) as T;
